import {
  DIR_LTR,
  NAV_TYPE_SIDE,
  SIDE_NAV_LIGHT,
} from "constants/ThemeConstant";
import { create } from "zustand";

export const useTheme = create((set) => ({
  navCollapsed: true,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  blankLayout: false,
  direction: DIR_LTR,
  toggleCollapsedNav: (navCollapsed) => {
    set({ navCollapsed });
  },
  onNavStyleChange: (sideNavTheme) => {
    set({ sideNavTheme });
  },
  onLocaleChange: (locale) => {
    set({ locale });
  },
  onNavTypeChange: (navType) => {
    set({ navType });
  },
  onTopNavColorChange: (topNavColor) => {
    set({ topNavColor });
  },
  onHeaderNavColorChange: (headerNavColor) => {
    set({ headerNavColor });
  },
  onMobileNavToggle: (mobileNav) => {
    set({ mobileNav });
  },
  onSwitchTheme: (currentTheme) => {
    set({ currentTheme });
  },
  onDirectionChange: (direction) => {
    set({ direction });
  },
  onBlankLayout: (blankLayout) => {
    set({ blankLayout });
  },
}));
